export default function StaticPageNavigation() {
  return (
    <div className="w-[20%] border-[1px] border-solid border-black">
      <p>Static Page Navigation</p>
    </div>
  );
}
